<template>
  <div class="card-item" @click="handleClick">
    <!-- 標題列與圖示 -->
    <div class="card-header">
      <div class="card-title-group">
        <i
          :class="card.completed ? 'el-icon-success checked' : 'el-icon-circle-check'"
          @click.stop="$emit('toggle-check', card)"
        ></i>
        <span :class="{ 'text-completed': card.completed }">{{ card.title }}</span>
      </div>
      <div class="card-actions" @click.stop>
        <el-button
          size="mini"
          icon="el-icon-delete action-icon"
          @click="$emit('archive', card)"
          circle
        ></el-button>
      </div>
    </div>

    <!-- 下方資訊 (到期日、評論、附件、成員) -->
    <div class="card-footer">
      <span
        v-if="card.dueDateTime"
        class="badge date-badge"
        :class="{ 'is-completed': card.completed }"
      >
        <i class="el-icon-time"></i> {{ formatDate(card.dueDateTime) }}
      </span>
      <span v-if="card.activities && card.activities.length > 0" class="badge-icon">
        <i class="el-icon-chat-square"></i> {{ card.activities.length }}
      </span>
      <span v-if="card.attachments && card.attachments.length > 0" class="badge-icon">
        <i class="el-icon-paperclip"></i> {{ card.attachments.length }}
      </span>
      <span v-if="card.members && card.members.length > 0" class="badge-icon">
        <el-avatar size="small" :src="getMember(card.members[0].id).avatar">
          {{ getMember(card.members[0].id).name.charAt(0) }}
        </el-avatar>
      </span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'CardItem',
  props: {
    card: { type: Object, required: true },
    memberOptions: { type: Array, default: () => [] },
  },
  methods: {
    async handleClick() {
      await this.$emit('click', this.card)
    },
    formatDate(date) {
      return dayjs(date).format('MM月DD日')
    },
    getMember(id) {
      return this.memberOptions.find(m => m.id === id) || { name: '未知成員', avatar: '' }
    },
  },
}
</script>

<style scoped lang="scss">
.card-item {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  border: 1px solid #dddddd;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  &:hover {
    border-color: #409eff;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title-group {
  display: flex;
  align-items: center;
  gap: 6px;
}
.checked {
  color: #8bc34a;
}
.text-completed {
  color: #888;
}
.action-icon {
  margin-left: 6px;
  color: #aaa;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
}
.card-footer {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  font-size: 12px;
  align-items: center;
}
.date-badge {
  color: #000;
  padding: 6px;
  border-radius: 4px;
  line-height: 16px;
  &.is-completed {
    background-color: #8bc34a;
  }
}
</style>
